import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
//import axios from './plugins/axios'

//Plugins
import './plugins'
// Components
import './components'


import VueSession from 'vue-session'
import router from '@/router'
import store from '@/store'
import { API_MIXINS } from '@/mixins/api_mixins.js'
import { GLOBAL_MIXINS } from '@/mixins/global_mixins.js'
import VueHtmlToPaper from 'vue-html-to-paper';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    '../print.css'
  ]
}

Vue.use(VueHtmlToPaper, options);


Vue.use(require('vue-moment'))
Vue.use(VueSession)
Vue.use(vue2Dropzone)
Vue.config.productionTip = false
Vue.mixin(API_MIXINS)
Vue.mixin(GLOBAL_MIXINS)
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBNyvotD5m-B7JLHYskCUhkSVO94w7LVFA', //AIzaSyB4OzobtrWq4ssT50_2LkNLEPa149P8GvA //AIzaSyBNyvotD5m-B7JLHYskCUhkSVO94w7LVFA
    v: 3.38,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
  // installComponents: true,
})
// window.console = console
//   console.log = function () {}

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
